import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitMergeAction extends WorkerAction {
  type: GitAction.Merge;
  params: { origin?: boolean; branch: string };
}

export class GitMergeActionError extends WorkerActionError {}

export async function GitMergeActionFn({ lg, params, util }: WorkerFnParams<GitMergeAction>): Promise<void> {
  try {
    const { branch } = params;
    lg.callAndCaptureOutput(['merge', branch]);
  } catch (err) {
    throw new GitMergeActionError(err);
  } finally {
    await util.syncfs(false);
  }
}
